<template>
  <el-card shadow="never" class="mb15">

    <h3>{{ $t('order_payment_title') }}</h3>

    <el-form :model="model" status-icon :inline="true" label-position="top">

      <el-form-item :label="$t('score')" prop="score" :error="error_form.score">
        <el-select v-model="model.score">
<!--          <el-option-->
<!--              :label="$store.getters.getUser.balance | n(2, '$')"-->
<!--              value="USD">-->
<!--          </el-option>-->
          <el-option
              :label="$store.getters.getUser.rub_balance || 0 | n(2, '₽')"
              value="RUB">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('amount')" prop="sum" :error="error_form.sum">
        <el-input v-model="model.sum"></el-input>
      </el-form-item>

      <el-form-item :label="$t('payment_method')" prop="method" :error="error_form.wallet_id" style="width: 500px;">
        <el-select v-model="model.wallet_id" style="width: 100%;">
          <el-option
              v-for="item in wallets"
              :key="item.id"
              :label="optionWalletLabel(item)"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('disbursement')" v-if="selectedCurrency && payoutTotal > 0">
        <el-input :value="payoutTotal | n(selectedCurrency.fraction_digits || 2)">
          <template slot="suffix" v-if="selectedCurrency">{{ selectedCurrency.symbol }}</template>
        </el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="order" :loading="loading_form">{{ $t('order_payment_button') }}</el-button>
      </el-form-item>
    </el-form>
    <el-alert
        v-if="emptyWallets"
        title="Добавьте Ваш кошелек в профиль, чтобы не пропустить выплату."
        type="error"
        effect="dark">
    </el-alert>
    <el-alert
        v-if="model.score && selectedCurrency && selectedCurrency.code !== model.score && currentCourse"
        :title="`Валюта счета отличается от валюты платежа. Курс ${model.score}/${selectedCurrency.code}: ${currentCourse}`"
        type="success"
        :closable="false"
        effect="dark">
      *курс является прогнозным и может отличаться в момент непосредственной выплаты
    </el-alert>
  </el-card>
</template>

<script>
import Vue from 'vue'
export default {
  name: "OrderPayment",
  data () {
    return {
      model: {score:'RUB'},
      error_form: {},
      loading_form: false,
      wallets: [],
      rates: [],
      emptyWallets: false
    };
  },
  computed: {
    selectedCurrency() {
      let wallet = this.wallets.find(x => x.id === this.model.wallet_id);
      if (wallet) {
        return wallet.method.currency;
      }
    },
    commission_percent() {
      let wallet = this.wallets.find(x => x.id === this.model.wallet_id);
      if (wallet) {
        return wallet.method.commission_percent;
      }
      return 0
    },
    payoutTotal() {
      if (this.model.wallet_id && this.model.sum) {
        let wallet = this.wallets.find(x => x.id === this.model.wallet_id);
        if (wallet) {
          let rate = this.rates.find(x => x.code_from === this.model.score && x.code_to === wallet.method.currency.code);
          return (this.model.sum - (this.model.sum/100*wallet.method.commission_percent))*rate.conversion_value - wallet.method.commission_fixed;
        }
      }
      return this.model.sum;
    },
    currentCourse() {
      if (this.model.wallet_id) {
        let wallet = this.wallets.find(x => x.id === this.model.wallet_id);
        if (wallet) {
          let sum = this.rates.find(x => x.code_from === this.model.score && x.code_to === wallet.method.currency.code).conversion_value
          if (sum < 1) {
            return Vue.filter('n')(1/sum, 2);
          }
          return sum;
        }
      }
      return 0;
    },
  },
  created () {
    this.$axios.get('/payment-wallets').then((res) => {
      this.wallets = res.data;
      if (!this.wallets.length) {
        this.emptyWallets = true
      }
    });

    this.$axios.get('/currencies/rates').then((res) => {
      this.rates = res.data;
    });
  },
  methods: {
    order() {
      this.loading_form = true;
      this.$axios.post('/payments', this.model).then((res) => {
        this.error_form = {};
        this.model = {};
        this.loading_form = false;
        this.$emit('update', res.data);
        this.$store.dispatch("getUser");
        this.$message({
          type: 'success',
          message: this.$t('notice.order_payment_success')
        });
      }).catch((error) => {
        this.error_form = error.response.data;
        this.loading_form=false;
      });
    },
    optionWalletLabel(item) {
        let s = item.method.name +' ('+item.method.currency.code+'): ' + Object.values(item.data).join(', ')
        if (item.method.commission_fixed && item.method.commission_percent) {
            return s + ' (Комиссия: '+item.method.commission_percent+'% + '+item.method.commission_fixed+''+item.method.currency.symbol+')'
        } else if (item.method.commission_fixed) {
            return s + ' (Комиссия: '+item.method.commission_fixed+''+item.method.currency.symbol+')'
        } else if (item.method.commission_percent) {
            return s + ' (Комиссия: '+item.method.commission_percent+'%)'
        }
        return s
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  margin-top: 0px;
  margin-bottom: 20px;
}
</style>